import { sanitizePdfDocDefinition } from 'utils/pdfTextSanitizer';
import i18n from 'i18next';
import moment from 'moment';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const docName = (settings) => {
    const documentName = `${i18n.t('reportName.' + settings.reportName)}`;
    const documentFilename = `${i18n.t(
        'reportFilename.' + settings.reportName
    )}_${moment().format('YYYY-MM-DD')}`;
    return { documentName, documentFilename };
};

export const createReport = (reportData, settings) => {
    const {
        recordDistanceMap,
        user,
        resourceWithAddress,
        employerObject,
        reportDaysSum,
        reportTripSum,
        reportDistanceSum,
        fromDate,
        toDate,
        profileImage,
    } = reportData;


    const fromDateString = moment(fromDate).format('DD.MM.YYYY');
    const toDateString = moment(toDate).format('DD.MM.YYYY');

    const { city, street1, street2, postcode } = resourceWithAddress;

    const projectRows = recordDistanceMap.map((project, index) => {
        return [
            {
                text: `${index + 1}. ${project.name} \n ${
                    project.street1 ? project.street1 : ''
                }${project.street2 ? ' ' + project.street2 : ''},${
                    project.postcode ? ' ' + project.postcode : ''
                } ${project.city ? project.city : ''}`,

                margin: [0, 5, 0, 5],
                alignment: 'left',
                borderColor: '#21a8e0',
            },
            {
                text: `${project.projectTripAmount} matkaa`,

                alignment: 'left',
                margin: [0, 5, 0, 5],
                borderColor: '#21a8e0',
            },
            {
                text: `${project.distanceString}`,

                alignment: 'left',
                margin: [0, 5, 0, 5],
                borderColor: '#21a8e0',
            },
            {
                text: `${project.distanceSum}`,

                alignment: 'left',
                margin: [0, 5, 0, 5],
                borderColor: '#21a8e0',
            },
        ];
    });

    // *** Full report doc def ***
    const docDefinition = {
        pageSize: 'LEGAL',
        pageMargins: [40, 40, 40, 100],
        content: [
            {
                columns: [
                    [
                        {
                            text: 'Työntekijän vuosiraportti verottajalle',
                            color: '#333333',
                            fontSize: 20,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 0, 0, 15],
                            width: 300,
                        },
                    ],
                ],
            },
            '\n\n',

            {
                columns: [
                    [
                        {
                            stack: [
                                {
                                    columns: [
                                        {
                                            text: `Ajanjaksolta:`,

                                            bold: true,
                                            width: '*',
                                            fontSize: 12,
                                            alignment: 'left',
                                        },
                                        {
                                            text: `${fromDateString} - ${toDateString}`,
                                            bold: true,
                                            fontSize: 12,
                                            alignment: 'left',
                                            width: 200,
                                        },
                                    ],
                                },
                                {
                                    columns: [
                                        {
                                            text: 'Yritys:',
                                            color: '#aaaaab',
                                            bold: true,
                                            width: '*',
                                            fontSize: 12,
                                            alignment: 'left',
                                        },
                                        {
                                            text: `${employerObject.name}`,
                                            bold: true,
                                            color: '#333333',
                                            fontSize: 12,
                                            alignment: 'left',
                                            width: 200,
                                        },
                                    ],
                                },
                                {
                                    columns: [
                                        {
                                            text: `Työntekijä:`,
                                            color: '#aaaaab',
                                            bold: true,
                                            width: '*',
                                            fontSize: 12,
                                            alignment: 'left',
                                        },
                                        {
                                            text: `${user.firstName} ${user.lastName}`,
                                            bold: true,
                                            color: '#333333',
                                            fontSize: 12,
                                            alignment: 'left',
                                            width: 200,
                                        },
                                    ],
                                },
                                {
                                    columns: [
                                        {
                                            text: `Syntymäaika:`,
                                            color: '#aaaaab',
                                            bold: true,
                                            width: '*',
                                            fontSize: 12,
                                            alignment: 'left',
                                        },
                                        {
                                            text: `${moment(
                                                user.dateOfBirth
                                            ).format('DD.MM.YYYY')}`,
                                            bold: true,
                                            color: '#333333',
                                            fontSize: 12,
                                            alignment: 'left',
                                            width: 200,
                                        },
                                    ],
                                },
                                {
                                    columns: [
                                        {
                                            text: `Veronumero:`,
                                            color: '#aaaaab',
                                            bold: true,
                                            width: '*',
                                            fontSize: 12,
                                            alignment: 'left',
                                        },
                                        {
                                            text: `${user.taxNumber}`,
                                            bold: true,
                                            color: '#333333',
                                            fontSize: 12,
                                            alignment: 'left',
                                            width: 200,
                                        },
                                    ],
                                },
                                {
                                    columns: [
                                        {
                                            text: `Kotiosoite:`,
                                            color: '#aaaaab',
                                            bold: true,
                                            width: '*',
                                            fontSize: 12,
                                            alignment: 'left',
                                        },
                                        {
                                            text: [
                                                [street1, street2]
                                                    .filter(Boolean)
                                                    .join(' '),
                                                [postcode, city]
                                                    .filter(Boolean)
                                                    .join(' '),
                                            ]
                                                .filter(Boolean)
                                                .join(', '),
                                            bold: true,
                                            color: '#333333',
                                            fontSize: 12,
                                            alignment: 'left',
                                            width: 200,
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                    profileImage
                        ? {
                              image: profileImage,
                              fit: [150, 150],
                              alignment: 'center',
                          }
                        : { text: '' },
                ],
            },
            '\n\n',
            {
                layout: {
                    defaultBorder: false,
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        if (i === 1 || i === 0) {
                            return '#bfdde8';
                        }
                        return '#eaeaea';
                    },
                    vLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    hLineStyle: function (i, node) {
                        // if (i === 0 || i === node.table.body.length) {
                        return null;
                        //}
                    },
                    // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                    paddingLeft: function (i, node) {
                        return 10;
                    },
                    paddingRight: function (i, node) {
                        return 10;
                    },
                    paddingTop: function (i, node) {
                        return 2;
                    },
                    paddingBottom: function (i, node) {
                        return 2;
                    },
                    fillColor: function (rowIndex, node, columnIndex) {
                        return '#fff';
                    },
                },
                table: {
                    headerRows: 1,
                    widths: ['*', 80, 80, 80],
                    body: [
                        [
                            {
                                text: 'Projekti',

                                margin: [0, 5, 0, 5],
                                textTransform: 'uppercase',
                                bold: true,
                            },
                            {
                                text: 'Matkojen määrä',

                                alignment: 'left',

                                margin: [0, 5, 0, 5],
                                textTransform: 'uppercase',
                                bold: true,
                            },
                            {
                                text: 'Työmatka',

                                alignment: 'left',

                                margin: [0, 5, 0, 5],
                                textTransform: 'uppercase',
                                bold: true,
                            },
                            {
                                text: 'Työmatka yhteensä',

                                alignment: 'left',

                                margin: [0, 5, 0, 5],
                                textTransform: 'uppercase',
                                bold: true,
                            },
                        ],
                    ].concat(projectRows),
                },
            },
            {
                layout: {
                    defaultBorder: false,
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    vLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    hLineStyle: function (i, node) {
                        // if (i === 0 || i === node.table.body.length) {
                        return null;
                        //}
                    },
                    // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                    paddingLeft: function (i, node) {
                        return 10;
                    },
                    paddingRight: function (i, node) {
                        return 10;
                    },
                    paddingTop: function (i, node) {
                        return 3;
                    },
                    paddingBottom: function (i, node) {
                        return 3;
                    },
                    fillColor: function (rowIndex, node, columnIndex) {
                        return '#fff';
                    },
                },
                table: {
                    headerRows: 1,
                    widths: ['*', 80, 80, 80],
                    body: [
                        [
                            {
                                text: 'Yhteensä:',
                                border: [false, true, false, false],
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                                color: '#4caf50',
                                bold: true,
                                borderColor: [
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                ],
                            },
                            {
                                border: [false, true, false, false],
                                text: `${reportTripSum} matkaa`,
                                alignment: 'left',
                                margin: [0, 5, 0, 5],
                                color: '#4caf50',
                                bold: true,
                                borderColor: [
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                ],
                            },
                            {
                                border: [false, true, false, false],
                                text: '',
                                alignment: 'left',
                                margin: [0, 5, 0, 5],
                                color: '#4caf50',
                                bold: true,
                                borderColor: [
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                ],
                            },
                            {
                                border: [false, true, false, false],
                                text: `${reportDistanceSum} km`,
                                alignment: 'left',
                                margin: [0, 5, 0, 5],
                                color: '#4caf50',
                                bold: true,
                                borderColor: [
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                ],
                            },
                        ],
                        [
                            {
                                text: '',
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                                color: '#4caf50',
                                bold: true,
                                borderColor: [
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                ],
                            },
                            {
                                text: ``,
                                alignment: 'left',
                                margin: [0, 5, 0, 5],
                                color: '#4caf50',
                                bold: true,
                                borderColor: [
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                ],
                            },
                            {
                                text: '',
                                alignment: 'left',
                                margin: [0, 5, 0, 5],
                                color: '#4caf50',
                                bold: true,
                                borderColor: [
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                ],
                            },
                            {
                                text: `${reportDaysSum} päivää*`,
                                alignment: 'left',
                                margin: [0, 5, 0, 5],
                                color: '#4caf50',
                                bold: true,
                                borderColor: [
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                    '#4caf50',
                                ],
                            },
                        ],
                    ],
                },
            },
            '\n',
            '\n',
            {
                text: '*Työnantaja ei maksa ateriakorvausta',
            },
            '\n',
            '\n',
            '\n',
            {
                text: 'Tietojen oikeellisuuden vahvistaa:',
            },
            '\n',
            '\n',
            '\n',
            '\n',
            {
                columns: [
                    [
                        {
                            table: {
                                headerRows: 1,
                                widths: [250],
                                body: [
                                    [
                                        {
                                            text: '',
                                            border: [false, false, false, true],
                                            margin: [0, 5, 0, 5],
                                            alignment: 'left',
                                        },
                                    ],
                                ],
                            },
                        },
                    ],
                    {},
                ],
            },
            '\n',
            {
                text: `${
                    employerObject.contact_first_name
                        ? employerObject.contact_first_name
                        : ''
                } ${
                    employerObject.contact_last_name
                        ? employerObject.contact_last_name
                        : ''
                }`,
            },
            {
                text: employerObject.name,
            },
        ],
        footer: function (currentPage, pageCount) {
            return {
                margin: [40, 5, 40, 5],
                layout: {
                    defaultBorder: false,
                    hLineWidth: function (i, node) {
                        return 1;
                    },
                    vLineWidth: function (i, node) {
                        return 1;
                    },
                    hLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    vLineColor: function (i, node) {
                        return '#eaeaea';
                    },
                    hLineStyle: function (i, node) {
                        // if (i === 0 || i === node.table.body.length) {
                        return null;
                        //}
                    },
                    // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                    paddingLeft: function (i, node) {
                        return 10;
                    },
                    paddingRight: function (i, node) {
                        return 10;
                    },
                    paddingTop: function (i, node) {
                        return 3;
                    },
                    paddingBottom: function (i, node) {
                        return 3;
                    },
                    fillColor: function (rowIndex, node, columnIndex) {
                        return '#fff';
                    },
                },
                table: {
                    headerRows: 1,
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: `Raportti on laadittu ja tiedot koottu Lixani projektinhallinta sovelluksesta`,
                                fontSize: 10,
                                alignment: 'center',
                                margin: [0, 5, 0, 5],
                            },
                        ],
                        [
                            {
                                image: 'data:image/png;base64,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',
                                width: 100,
                                alignment: 'center',
                            },
                        ],
                    ],
                },
            };
        },

        styles: {
            notesTitle: {
                fontSize: 10,
                bold: true,
                margin: [0, 50, 0, 3],
            },
            notesText: {
                fontSize: 10,
            },
        },
        defaultStyle: {
            columnGap: 20,
            //font: 'Quicksand',
        },
    };
    return new Promise((resolve) => {
        pdfMake.createPdf(sanitizePdfDocDefinition(docDefinition)).getBase64((base64) => resolve(base64));
    });
};
